import { TopBar } from "../../../components/widgets/top-bar/TopBar";
import { IslandLayout } from "../../../layouts/island-layout/IslandLayout";
import { BillingDetails } from "../components/profile-settings/BillingDetails";
import { SupportComponent } from "../components/support-components/SupportComponent";

function ProfileSettingsPage() {
  return (
    <>
      <TopBar title="Billing">
        <SupportComponent />
      </TopBar>
      <div className="billing-layout">
        <IslandLayout>
          <div className="user-table">
            <BillingDetails />
          </div>
        </IslandLayout>
      </div>
    </>
  );
}

export { ProfileSettingsPage };
